// removed by extract-text-webpack-plugin
module.exports = {"extraNutritionalInformation":"Ge33e30 Gfcb5ff Gd71c60","extraInfoMargins":"Gf48290 Gf3d5f3"};